// components/About/PhotoSection.jsx
import React from "react";
import { motion } from "framer-motion";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import { whyChooseUs } from "config/aboutData"; // Make sure this is imported
import leftImage from "assets/Images/pexels-pixabay-60504.jpg";
import rightImage from "assets/Images/photo1.jpg";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.2, duration: 0.6 },
  }),
};

export default function PhotoSection() {
  return (
    <MKBox
      display="flex"
      flexDirection={{ xs: "column", md: "row" }}
      justifyContent="space-between"
      alignItems="center"
      px={4}
      py={6}
      gap={4}
      mt={-2} // Moves section slightly higher
    >
      {/* Left Image */}
      <motion.div initial="hidden" whileInView="visible" variants={fadeUp}>
        <MKBox
          component="img"
          src={leftImage}
          alt="Left Visual"
          width={{ xs: "100%", md: "300px" }}
          height="auto"
          borderRadius="lg"
          boxShadow="xl"
        />
      </motion.div>

      {/* Center Why Choose Us */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        variants={fadeUp}
        style={{ flex: 1, textAlign: "center" }}
      >
        <MKTypography variant="h4" fontWeight="bold" mb={2}>
          Why Choose Us
        </MKTypography>
        <MKBox display="flex" flexDirection="column" alignItems="center" gap={1.5}>
          {whyChooseUs.map((point, i) => (
            <motion.div
              key={i}
              custom={i}
              variants={fadeUp}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.6rem",
              }}
            >
              <MKTypography variant="body2">{point}</MKTypography>
            </motion.div>
          ))}
        </MKBox>
      </motion.div>

      {/* Right Image */}
      <motion.div initial="hidden" whileInView="visible" variants={fadeUp}>
        <MKBox
          component="img"
          src={rightImage}
          alt="Right Visual"
          width={{ xs: "100%", md: "300px" }}
          height="auto"
          borderRadius="lg"
          boxShadow="xl"
        />
      </motion.div>
    </MKBox>
  );
}
